import { validateAddress, type AddressValidationVerdict } from '@/services/addressValidation';
import type { ShippingData } from '@/types/registration';

type ShippingForm = {
  first: string;
  last: string;
  street: string;
  apt: string;
  city: string;
  state: string;
  zip: string;
};

const EMPTY_SHIPPING: ShippingForm = {
  first: '',
  last: '',
  street: '',
  apt: '',
  city: '',
  state: '',
  zip: '',
};

const normalizeZip = (value: string): string => value.replace(/\D/g, '').slice(0, 5);

const zipIsValid = (zip: string): boolean => /^\d{5}$/.test(zip);

const shippingIsComplete = (f: ShippingForm): boolean =>
  Boolean(
    f.first.trim() &&
      f.last.trim() &&
      f.street.trim() &&
      f.city.trim() &&
      f.state.trim() &&
      zipIsValid(f.zip),
  );

const toShippingData = (f: ShippingForm): ShippingData => ({
  firstName: f.first.trim(),
  lastName: f.last.trim(),
  streetAddress: f.street.trim(),
  apartment: f.apt.trim(),
  city: f.city.trim(),
  state: f.state.trim(),
  zipCode: f.zip,
});

const checkShippingAddress = async (f: ShippingForm): Promise<AddressValidationVerdict> => {
  try {
    return await validateAddress({
      streetAddress: [f.street.trim(), f.apt.trim()].filter(Boolean).join(' '),
      city: f.city.trim(),
      state: f.state.trim(),
      zipCode: f.zip,
    });
  } catch {
    return { isValid: true };
  }
};

export {
  EMPTY_SHIPPING,
  checkShippingAddress,
  normalizeZip,
  shippingIsComplete,
  toShippingData,
  zipIsValid,
};
export type { ShippingForm };
